export const Constants = {
    AUTH_KEY: 'auth',
    DATATABLE: {
        NO_DATA: "Have no data !"
    },
    QUERY: {
        LIMIT: 20
    },
    MAX_FILE_SIZE_UPLOAD: 2
}